import api from "../../services/instanceapi";
import {linksURL} from "../../services/api";
import {checkErrorMessage} from "../../utils/utils";


export const POST_LINK = "POST_LINK"
export const GET_LINK = "GET_LINK"
export const PATCH_LINK = "PATCH_LINK"
export const POST_LINK_FAIL = "POST_LINK_FAIL"
export const PATCH_LINK_FAIL = "PATCH_LINK_FAIL"
export const GET_LINK_FAIL = "GET_LINK_FAIL"
export const CLEAR_LINK  = 'CLEAR_LINK'
export const DELETE_LINK  = 'DELETE_LINK'
export const DELETE_LINK_FAIL  = 'DELETE_LINK_FAIL'
export const postLinks = (data) => async (dispatch) => {
    try {
        await api.post(linksURL(), data);
        dispatch({
            type: POST_LINK
        })
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: POST_LINK_FAIL,
                payload: {
                    message: message,
                    status: status,
                },
            });
        }
        return Promise.reject(e)
    }
}

export const getLink = (id) => async (dispatch) => {
    try {
        const link = await api.get(linksURL(id))
        const data = link.data
        dispatch({
            type: GET_LINK,
            payload: {
                name: data.name,
                url: data.url,
                author: data.author,
                projectId: data.projectId
            }
        })
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: GET_LINK_FAIL,
                payload: {
                    message: message,
                    status: status,
                },
            });
        }
        return Promise.reject(e)
    }
}


export const patchLink = (id, data) => async (dispatch) => {
    try {
        await api.patch(linksURL(id), data);
        dispatch({
            type: PATCH_LINK
        })
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: PATCH_LINK_FAIL,
                payload: {
                    message: message,
                    status: status,
                },
            });
        }
        return Promise.reject(e)
    }
}

export const deleteLink = (id) => async (dispatch) => {
    try {
        await api.delete(linksURL(id));
        dispatch({
            type: DELETE_LINK
        })
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: DELETE_LINK_FAIL,
                payload: {
                    message: message,
                    status: status,
                },
            });
        }
        return Promise.reject(e)
    }
}
